import React from 'react';
import Analytics from './windowAnalytics';
import Location from './windowLocation';
import { getRuntimeConfig } from './runtimeConfig';

export default class TrackableReact extends React.Component {
    componentDidMount() {
        // Subclasses that never initialise state have this.state === null.
        const userId = this.state?.userId;
        if (userId /*&& !Analytics.storedId*/) {
            window.analytics.identify(userId);
            //Analytics.storedId = userId;
        }

        if (Location.href !== Analytics.priorHref) {
            window.analytics.page();
            Analytics.priorHref = Location.href;
        }


    }

    track = (event, properties, options, callback) => {
        if (!properties) properties = {};
        if (!properties.source) properties.source = "Connect (Client)";
        const runtime = getRuntimeConfig();
        if (!properties.environment) properties.environment = runtime.environmentName;
        if (!properties.deploymentTier) properties.deploymentTier = runtime.deploymentTier;
        if (!properties.publicOrigin) properties.publicOrigin = runtime.publicOrigin;
        // Per-org slicing in Amplitude/LogRocket: attach the user's primary
        // org (cached at identify time) to every event unless the caller
        // already set one explicitly.
        try {
            if (!properties.orgId) {
                const orgId = localStorage.getItem('audirie_primary_org_id');
                const orgName = localStorage.getItem('audirie_primary_org_name');
                if (orgId) properties.orgId = orgId;
                if (orgName && !properties.orgName) properties.orgName = orgName;
            }
        } catch (err) { /* localStorage unavailable — send without org */ }
        window.analytics.track(event, properties, options, callback);
    }

    identify = (id, traits, options) => {
        //if (Analytics) {
        //    Analytics.identify(id, traits, options);
        //} else {
        const includedTraits = ['email', 'firstName', 'lastName', 'name', 'memberDetails', 'userStatus'];
        let newTraits = {};

        includedTraits.forEach(key => {
            if (traits && traits[key]) {
                if (key == "memberDetails" && Array.isArray(traits[key])) {
                    newTraits[key] = [];
                    for (let thisOrg of traits[key]) {
                        newTraits[key].push(thisOrg.company);
                    }                    
                } else {
                    newTraits[key] = traits[key] 
                }
            }
        });

        // Structured org traits so Amplitude groups / LogRocket session traits
        // can slice by organisation id, not just company name. memberDetails
        // (names only) is kept unchanged for existing dashboards.
        if (traits && Array.isArray(traits.memberDetails)) {
            const organisations = traits.memberDetails
                .filter(org => org && org.orgId)
                .map(org => ({ orgId: String(org.orgId), orgName: org.company || null }));
            if (organisations.length > 0) {
                newTraits.organisations = organisations;
                newTraits.orgIds = organisations.map(org => org.orgId);
                newTraits.primaryOrgId = organisations[0].orgId;
                newTraits.primaryOrgName = organisations[0].orgName;
                try {
                    localStorage.setItem('audirie_primary_org_id', organisations[0].orgId);
                    if (organisations[0].orgName) {
                        localStorage.setItem('audirie_primary_org_name', organisations[0].orgName);
                    }
                } catch (err) { /* localStorage unavailable */ }
            }
        }
    
        try {
            let resetTraits = false;
            let oldUserId = "";
            try {
                oldUserId = JSON.parse(localStorage.getItem('ajs_user_id'));
            } catch (errUserId) {
                console.error(`[TrackableReact] Could not get old userId`);
                console.error(errUserId);
            }
            if (oldUserId != id) resetTraits = true;
            let oldUserTraits = "";
            try {
                oldUserTraits = JSON.parse(localStorage.getItem(`ajs_user_traits`));
            } catch (errUserTraits) {
                console.error(`[TrackableReact] Could not get old user traits`);
                console.error(errUserTraits);
            }
            if (oldUserTraits?.toString()?.length > 10000) resetTraits = true;
            if (resetTraits) {
                //window.analytics.reset()
                localStorage.setItem(`ajs_user_traits`, []);
            }
        } catch (err) {
            console.error(`[TrackableReact] Could not clear user traits`);
            console.error(err);
        }
        window.analytics.identify(id, newTraits, options);
        //}
    }
}